export default __webpack_public_path__ + "static/media/video.80f3bbd4.png";